import React from "react";
import { Label } from "../../../../components/ui/label";
import { ItemsPerPageToggleGroup } from "../per-page-input";
import { useTranslation } from "../../../../contexts/I18nProvider";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentPage,
  setItemsPerPage,
} from "../../../../redux/slices/filterSlice";
import { Info } from "lucide-react";

function SentencesPerPageInput({ variant = "stacked", className = "" }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { maxItemsPerPage, itemsPerPage } = useSelector(
    (state) => state.filters
  );

  const handleItemsPerPageChange = (value) => {
    if (value === "") {
      dispatch(setItemsPerPage(1));

      return;
    }
    const numericValue = parseInt(value, 10);
    if (!isNaN(numericValue) && numericValue > 0) {
      const limitedValue = Math.min(numericValue, maxItemsPerPage);
      dispatch(setItemsPerPage(limitedValue));
      dispatch(setCurrentPage(1));
    }
  };

  if (variant === "inline") {
    return (
      <div className={`flex flex-wrap items-center gap-2 ${className}`}>
        <div className="flex items-center gap-1 group relative">
          <Label htmlFor="items-per-page" className="text-xs text-muted-foreground">
            {t('polyglot.perPage')}
          </Label>
          <Info className="w-3.5 h-3.5 text-muted-foreground hover:text-primary transition-colors cursor-help" 
                title={t('polyglot.sentencesPerPageTooltip')} />
          <span className="absolute bottom-full left-0 mb-2 hidden group-hover:block bg-slate-900 text-white text-xs py-1 px-2 rounded whitespace-nowrap z-50">
            {t('polyglot.sentencesPerPageTooltip')}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <ItemsPerPageToggleGroup
            defaultValue={itemsPerPage}
            onChange={handleItemsPerPageChange}
            className="rounded-xl border border-input shadow-sm"
            title="Select the number of sentences to display"
          />
        </div>
      </div>
    );
  }
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 group relative">
        <Label htmlFor="items-per-page">
          {t('polyglot.sentencesPerPage', { count: maxItemsPerPage })}
        </Label>
        <Info className="w-4 h-4 text-muted-foreground hover:text-primary transition-colors cursor-help" 
              title={t('polyglot.sentencesPerPageTooltip')} />
        <span className="absolute bottom-full left-0 mb-2 hidden group-hover:block bg-slate-900 text-white text-xs py-1 px-2 rounded whitespace-nowrap z-50">
          {t('polyglot.sentencesPerPageTooltip')}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <ItemsPerPageToggleGroup
          defaultValue={itemsPerPage}
          onChange={handleItemsPerPageChange}
          title="Select the number of sentences to display"
        />
      </div>
    </div>
  );
}

export default SentencesPerPageInput;
